import {Injectable} from '@angular/core';
import {tuningsStore} from './tunings.store';
import {Tunings} from '../../../types/tunings';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class TuningsManager {
  public setLoading(value: boolean) {
    tuningsStore.update(setProps({isLoading: value}));
  }

  public setTunings(tunings: Partial<Tunings>) {
    tuningsStore.update(setProps({tunings: tunings}));
  }

  public setTuningsFetched(value: boolean) {
    tuningsStore.update(setProps({tuningsFetched: value}));
  }

  public setUpdatedTunings(tunings: Partial<Tunings>) {
    tuningsStore.update(setProps({updatedTunings: tunings}));
  }

  public reset() {
    tuningsStore.reset();
  }
}
